import React, { FC } from 'react';

export interface AutumnLeafProps {
  size?: number;
  color: string;
  className?: string;
  style?: React.CSSProperties;
}

/** A simple maple-ish leaf used for the falling-leaves animations. */
export const AutumnLeaf: FC<AutumnLeafProps> = ({ size = 18, color, className, style }) => (
  <svg
    className={className}
    style={style}
    width={size}
    height={size}
    viewBox='0 0 24 24'
    aria-hidden='true'
    data-testid='AutumnLeaf'>
    <path
      d='M12 2c1 3 3 5 6 6-2 1-3 2-3 4 2 0 4 1 6 3-3 0-5 1-6 3 0-2-1-3-3-4-2 1-3 2-3 4-1-2-3-3-6-3 2-2 4-3 6-3 0-2-1-3-3-4 3-1 5-3 6-6z'
      fill={color}
    />
    <path d='M12 11v11' stroke='rgba(0,0,0,0.25)' strokeWidth='1' strokeLinecap='round' />
  </svg>
);

export default AutumnLeaf;
